import { render, staticRenderFns } from "./R19.vue?vue&type=template&id=00ff52d2"
import script from "./R19.vue?vue&type=script&lang=js"
export * from "./R19.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports